import { useConnectionStatus } from '../adapters/webSocket';

// Small, non-blocking indicator that the live socket connection has dropped and is
// recovering — mounted on any screen whose data depends on a live socket (match-play,
// spectate, bracket). Renders nothing once connected and not mid-reconnect.
export default function ConnectionStatusBanner() {
  const { connected, reconnecting } = useConnectionStatus();
  if (connected && !reconnecting) return null;

  return (
    <div style={{
      position: 'fixed', top: 'calc(var(--header-h, 0px) + 8px)', right: '8px', zIndex: 250,
      display: 'flex', alignItems: 'center', gap: '0.4rem',
      background: 'rgba(230,126,34,0.16)', border: '1px solid rgba(230,126,34,0.5)',
      borderRadius: '999px', padding: '0.35rem 0.75rem',
      fontSize: '0.72rem', fontWeight: 700, color: '#e67e22', letterSpacing: '0.02em',
      boxShadow: '0 4px 16px rgba(0,0,0,0.3)',
    }}>
      ⚠ Reconnecting…
    </div>
  );
}
